export const practices_PromoteEvents = [
	{
		icon: '✅',
		title: 'practicesData_title1',
		subtitle: 'practicesData_subtitle1',
	},
	{
		icon: '✅',
		title: 'practicesData_title2',
		subtitle: 'practicesData_subtitle2',
	},
	{
		icon: '✅',
		title: 'practicesData_title3',
		subtitle: 'practicesData_subtitle3',
	},
	{
		icon: '✅',
		title: 'practicesData_title4',
		subtitle: 'practicesData_subtitle4',
	},
	{
		icon: '✅',
		title: 'practicesData_title5',
		subtitle: 'practicesData_subtitle5',
	},
];
